import { useTranslation } from 'react-i18next';
import Toggle from '@/components/toggle/toggle';
import { useSetMyAvailability } from '@/hooks/use-salespeople/use-salespeople';
import { useUser } from '@/hooks/use-user/use-user';
import { OUTBOUND_POLL_INTERVAL_MS } from '@/services/outbound-calls-service/outbound-calls.constants';
import { openNotification } from '@/utils/notification/notification';
import styles from './sales-agent-toggle.module.scss';

/**
 * The signed-in salesperson's own availability, from the page header. Polled: a transfer
 * makes them busy and "available" ends by itself after working hours, with no socket to say so.
 */
export function SalesAgentToggle() {
  const { t } = useTranslation('outbound');
  const { userData } = useUser({ refetchInterval: OUTBOUND_POLL_INTERVAL_MS });
  const { setMyAvailability, isPending } = useSetMyAvailability();
  const salesAgent = userData?.sales_agent;

  if (!salesAgent) return null;

  const handleChange = (available: boolean) =>
    setMyAvailability(available ? 'available' : 'offline').catch(() =>
      openNotification({ type: 'error', message: t('myAvailability.failed') })
    );

  return (
    <div className={styles.availability}>
      <Toggle
        checked={salesAgent.status === 'available'}
        // `user_data` does not say where a busy salesperson goes after the call, so the
        // switch waits for the call to end rather than show a guess.
        disabled={isPending || salesAgent.status === 'busy'}
        label={t('myAvailability.label')}
        onChange={handleChange}
      />
      <span className={styles.status}>{t(`myAvailability.${salesAgent.status}`)}</span>
    </div>
  );
}
